import { render, staticRenderFns } from "./CustomColumnDropdown.vue?vue&type=template&id=821477b4"
import script from "./CustomColumnDropdown.vue?vue&type=script&lang=js"
export * from "./CustomColumnDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports